import React, { useEffect } from "react";
import { ClassicTemplate, CreativeTemplate, ModernTemplate } from "@/Assets/Index.js";

const TemplateImagePreloader = () => {
  useEffect(() => {
    // Template images to preload
    const templateImages = [ClassicTemplate, ModernTemplate, CreativeTemplate];

    // Preload all template images in background
    templateImages.forEach((imageSrc, index) => {
      if (imageSrc) {
        const img = new Image();
        img.onload = () => {};
        img.onerror = (error) => {
          console.error(`Failed to preload template image ${index + 1}:`, error);
        };
        img.src = imageSrc;
      }
    });
  }, []);

  // Return null as this is just a background preloader
  return null;
};

export default TemplateImagePreloader;
